import { useContext, useEffect, useState } from 'react';
import { UserContext } from '@adflow/utils';

export const TEMPLATE_BUILDER_ANIMATIONS_FEATURE = 'cm-template-builder-animations';

export function useTemplateAnimationsFeature(): boolean {
  const { user } = useContext(UserContext);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const checkFeature = async () => {
      const hasFeature = (await user?.hasFeature(TEMPLATE_BUILDER_ANIMATIONS_FEATURE)) ?? false;
      if (!cancelled) {
        setEnabled(hasFeature);
      }
    };
    checkFeature().catch((error) => {
      console.warn('Failed to check template builder animations feature', error);
      if (!cancelled) {
        setEnabled(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return enabled;
}
